// Function to ensure the canvas always stays white for a11y reasons.
export const whiteCanvas = {
  id: 'custom_canvas_background_color',
  beforeDraw: (chart) => {
    const ctx = chart.canvas.getContext('2d');
    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  },
};

// Function to change the legend style if the chart type is line.
export const lineLegend = {
  id: 'custom_canvas_legend',
  beforeDraw: (chart) => {
    if (chart.config._config.type !== 'line') {
      return;
    }
    if (chart.config.data.datasets[0].borderColor) {
      const legends = chart.legend.legendItems;
      legends.forEach((legend, i) => {
        legend.fillStyle = chart.config.data.datasets[i].borderColor;
        legend.strokeStyle = chart.config.data.datasets[i].borderColor;
      });
    }
  },
};

// Array of commonly used colors that can be added to color pickers.
export const defaultColors = [
  {
    name: 'Black',
    slug: 'black',
    color: '#000000',
  },
  {
    name: 'Cyan bluish gray',
    slug: 'cyan-bluish-gray',
    color: '#abb8c3',
  },
  {
    name: 'White',
    slug: 'white',
    color: '#ffffff',
  },
  {
    name: 'Pale pink',
    slug: 'pale-pink',
    color: '#f78da7',
  },
  {
    name: 'Vivid red',
    slug: 'vivid-red',
    color: '#cf2e2e',
  },
  {
    name: 'Luminous vivid orange',
    slug: 'luminous-vivid-orange',
    color: '#ff6900',
  },
  {
    name: 'Luminous vivid amber',
    slug: 'luminous-vivid-amber',
    color: '#fcb900',
  },
  {
    name: 'Light green cyan',
    slug: 'light-green-cyan',
    color: '#7bdcb5',
  },
  {
    name: 'Vivid green cyan',
    slug: 'vivid-green-cyan',
    color: '#00d084',
  },
  {
    name: 'Pale cyan blue',
    slug: 'pale-cyan-blue',
    color: '#8ed1fc',
  },
  {
    name: 'Vivid cyan blue',
    slug: 'vivid-cyan-blue',
    color: '#0693e3',
  },
  {
    name: 'Vivid purple',
    slug: 'vivid-purple',
    color: '#9b51e0',
  },
];

// Handles the color change for color picker components.
export const handleColorChange = (selectedColor, index, setAttributesFunc, colorsArrayAttr) => {
  const tempColors = colorsArrayAttr;
  if (index !== -1) {
    tempColors[index] = selectedColor;
  }
  setAttributesFunc({ colorsArray: [...tempColors] });
};

// Handles the border color change for color picker components.
export const handleLineBorderColorChange = (
  selectedColor,
  index,
  setAttributesFunc,
  borderColorsArrayAttr,
) => {
  const tempColors = borderColorsArrayAttr;
  if (index !== -1) {
    tempColors[index] = selectedColor;
  }
  setAttributesFunc({ lineBorderColors: [...tempColors] });
};

// Handles the border color change for color picker components.
export const handleBorderColorChange = (selectedColor, setAttributesFunc) => {
  setAttributesFunc({ borderColor: selectedColor });
};
